import script from "./user_card.vue?vue&type=script&setup=true&lang=js"
export * from "./user_card.vue?vue&type=script&setup=true&lang=js"

import "./user_card.vue?vue&type=style&index=0&id=95daf698&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95daf698"]])

export default __exports__